import moment from 'moment';
import jstz from 'jstz';

// TableDate
export default function TableDateFilter($ngRedux, usersService) {
  'ngInject';
  return function(input) {
    if (input == null) {
      return '';
    }
    let dateFormat = '';
    if ($ngRedux !== undefined) {
      const store = $ngRedux.getState();
      dateFormat = store.user.dateFormat;
    }
    let currentUser = usersService.currentUser();
    let timezone;
    if (currentUser) {
      let claimsData = currentUser.claims.data;
      timezone = claimsData.timezone;
      if (!timezone) {
        let zone = jstz.determine();
        timezone = zone.name();
      }
    } else {
      let zone = jstz.determine();
      timezone = zone.name();
    }
    let datetimeformat = `${dateFormat} h:mm:ss A`;

    let output = moment(input)
      .tz(timezone)
      .format(datetimeformat);
    return output;
  };
}
